export class ExportDocumentReadyEventArgs {
    public url: string;
    public format: string;
    public handled: boolean = false;
    public windowOpenTarget: string;

    constructor(url: string, format: string, windowOpenTarget: string) {
        this.url = url;
        this.format = format;
        this.windowOpenTarget = windowOpenTarget;
    }
}
